import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useMemo, useCallback, useEffect } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { Person } from "@mui/icons-material";
import { FormControl, Button, MenuItem, Typography, Switch, Divider, chipClasses } from "@mui/material";
import "lottie-react";
import "../../../../../themes/shadows/shadows.js";
import "../../../../../themes/typography/typography.js";
import "../../../../../components/avatar-group/avatar-group.styles.js";
import { Chip } from "../../../../../components/chip/chip.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.js";
import "../../../../../components/date-pickers/date-picker/theme/index.js";
import "../../../../../components/dialog/dialog.js";
import "../../../../../components/icons/all/all.js";
import "../../../../../components/label/label.styles.js";
import { MenuItem as MenuItem$1 } from "../../../../../components/menu-item/menu-item.js";
import "../../../../../components/slider/slider.styles.js";
import "@mui/material/styles";
import "../../../../../components/snackbar/snackbar.styles.js";
import "../../../../../components/styled-text-field/styled-text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.js";
import "../../../../../components/translations/utils.js";
import "../../../../../components/time-select/time-select.styles.js";
import "../../../../../components/time-interval-select/time-interval-select.styles.js";
import { CrossIcon } from "../../assets/icons/Cross.js";
import { EmployeeIcon } from "../../assets/icons/Employee.js";
import { toggleArray } from "../../helpers/common.js";
import { useEmployeeSearch } from "../../hooks/useEmployeeSearch.js";
import { LABEL_OFFSET } from "../appointment-form/appointment-form.constants.js";
import { EmployeeAutocompleteSkeleton } from "./employee-select.skeleton.js";
import { StyledInputLabel, StyledSelect, ChipsStack, ToggleWrapper, StyledFormHelperText } from "./employee-select.styles.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "@mui/system";
import "@mui/material/Chip/index.js";
import "../../../../../components/chip/chip.styles.js";
import "@mui/material/Button/index.js";
import "@mui/x-date-pickers/internals/index.js";
import "../../../../../constants/create-theme/create-theme.js";
import "../../../../../constants/colors/palette.js";
import "../../../../../themes/button/button.js";
import "../../../../../themes/button/styles/external/bordered.styles.js";
import "color-alpha";
import "../../../../../themes/button/styles/external/filled.styles.js";
import "../../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../../components/date-pickers/pickers-action-bar/pickers-action-bar.styles.js";
import "../../../../../themes/date-calendar/date-calendar.js";
import "../../../../../themes/date-picker-toolbar/date-picker-toolbar.js";
import "../../../../../themes/day-calendar/day-calendar.js";
import "../../../../../themes/filled-input/filled-input.js";
import "../../../../../themes/form-helper-text/form-helper-text.js";
import "../../../../../themes/form-label/form-label.js";
import "../../../../../themes/month-calendar/month-calendar.js";
import "../../../../../themes/pickers-arrow-switcher/pickers-arrow-switcher.js";
import "../../../../../themes/pickers-calendar-header/pickers-calendar-header.js";
import "../../../../../themes/pickers-day/pickers-day.js";
import "@mui/x-date-pickers";
import "../../../../../themes/pickers-month/pickers-month.js";
import "../../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../../themes/pickers-toolbar/pickers-toolbar.js";
import "../../../../../themes/pickers-year/pickers-year.js";
import "../../../../../themes/year-calendar/year-calendar.js";
import "@mui/icons-material/Close.js";
import "../../../../../themes/alert/alert.js";
import "../../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../../themes/dialog/dialog.js";
import "../../../../../themes/external-theme/external-theme.js";
import "../../../../../constants/breakpoints/breakpoints.js";
import "../../../../../themes/checkbox/checkbox.js";
import "../../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../../themes/form-control-label/form-control-label.js";
import "../../../../../themes/radio/radio.js";
import "../../../../../themes/switch/switch.js";
import "../../../../../themes/popover/popover.js";
import "../../../../../themes/tooltip/tooltip.js";
import "../../../../../components/dialog/dialog.constants.js";
import "../../../../../components/dialog/dialog.styles.js";
import "@emotion/react";
import "../../../../../components/dialog/DraggablePaperComponent.js";
import "react-draggable";
import "../../../../../components/icons/CalendarEventIcon/CalendarEventIcon.js";
import "../../../../../components/icons/MainIcon/MainIcon.js";
import "../../../../../components/icons/CalendarIcon/CalendarIcon.js";
import "../../../../../components/icons/CardIcon/CardIcon.js";
import "../../../../../components/icons/ChecklistIcon/ChecklistIcon.js";
import "../../../../../components/icons/ClockIcon/ClockIcon.js";
import "../../../../../components/icons/CloseIcon/CloseIcon.js";
import "../../../../../components/icons/EditIcon/EditIcon.js";
import "../../../../../components/icons/EmptyCalendar/EmptyCalendar.js";
import "../../../../../components/icons/EventNote/EventNote.js";
import "../../../../../components/icons/FilterIcon/FilterIcon.js";
import "../../../../../components/icons/ListIcon/ListIcon.js";
import "../../../../../components/icons/MessageBubble/MessageBubble.js";
import "../../../../../components/icons/PhoneIcon/PhoneIcon.js";
import "../../../../../components/icons/PinIcon/PinIcon.js";
import "../../../../../components/icons/SearchIcon/SearchIcon.js";
import "../../../../../components/icons/TherapyNotesIcon/TherapyNotesIcon.js";
import "../../../../../components/icons/TimerIcon/TimerIcon.js";
import "../../../../../components/icons/TreatmentChairIcon/TreatmentIcon.js";
import "../../../../../components/icons/VisibilityOffIcon/VisibilityOffIcon.js";
import "../../../../../components/icons/WarningIcon/WarningIcon.js";
import "@mui/material/MenuItem/index.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.js";
import "../../../../../components/menu-item/assets/icons/minus-circle.js";
import "../../../../../components/menu-item/assets/icons/plus-circle.js";
import "../../../../../components/menu-item/components/menu-item-counter/menu-item-counter.styles.js";
import "../../../../../components/menu-item/menu-item.styles.js";
import "../../../../../components/avatar/avatar.js";
import "@mui/material/Avatar/index.js";
import "../../../../../components/avatar/avatar.styles.js";
import "@mui/material/Snackbar/index.js";
import "../../../../../components/snackbar/snackbar.types.js";
import "../../../../../components/text-field/text-field.js";
import "@mui/material/TextField/index.js";
import "../../../../../components/text-field/text-field.styles.js";
import "../../../../../components/swipeable-drawer/swipeable-drawer.styles.js";
import "react-i18next";
import "../../../../../type/Translations.js";
import "contentful";
import "i18next";
import "lodash/set.js";
import "remarkable";
import "remarkable-react";
import "@mui/icons-material/Timer.js";
import "@mui/material/FormControl/index.js";
import "@mui/material/InputLabel/index.js";
import "@mui/material/Select/index.js";
import "@mui/material/Box/index.js";
import "date-fns";
import "date-fns/locale";
import "../../appointment-details.types.js";
import "@tanstack/react-query";
import "../../providers/axios-provider.js";
import "axios";
const TOGGLE_ALL_VALUE = "toggle-all";
const menuProps = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "left"
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "left"
  },
  slotProps: {
    paper: {
      sx: {
        borderRadius: "0 0 4px 4px"
      }
    }
  }
};
const EmployeeSelect = ({
  clinicReferenceId,
  labels,
  canUseRandomEmployee = false,
  isNewAppointment = false,
  role,
  maxChips = 4
}) => {
  const [open, setOpen] = useState(false);
  const { control, watch, setValue } = useFormContext();
  const treatmentReferenceId = watch("treatmentReferenceId");
  const {
    data: employees = [],
    queryResult: { isFetching }
  } = useEmployeeSearch({
    treatmentReferenceId,
    clinicReferenceId
  });
  const options = useMemo(
    () => employees.filter(
      ({ practitionerPositions }) => !treatmentReferenceId || practitionerPositions.some(({ role: employeeRole }) => role === employeeRole)
    ).map((employee) => ({
      label: employee.userName ?? employee.displayName,
      value: employee
    })),
    [employees, treatmentReferenceId, canUseRandomEmployee]
  );
  const handleEmployeeChange = (onChange, value) => (e) => {
    const hasLastValue = !e.target.value.length || e.target.value[e.target.value.length - 1] !== TOGGLE_ALL_VALUE;
    const toggleValue = value.length === options.length ? [] : options.map((option) => option.value.referenceId);
    onChange(hasLastValue ? e.target.value : toggleValue);
    if (isNewAppointment)
      setValue("startTime", null, { shouldValidate: true, shouldDirty: true, shouldTouch: true });
  };
  const handleDeleteChip = useCallback(
    (id, value) => () => {
      setValue(`employeeByRole.${role}`, toggleArray(value, id));
    },
    []
  );
  const handleDeleteAllChips = () => {
    setValue(`employeeByRole.${role}`, []);
  };
  const handleSelectClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };
  const handleInputClick = (event) => {
    const element = event.target;
    const classes = Array.from((element == null ? void 0 : element.classList) ?? []);
    const isChipClicked = classes.some((clickedChip) => Object.values(chipClasses).includes(clickedChip)) || element.nodeName === "path";
    if (isChipClicked) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      setOpen(true);
    }
  };
  useEffect(() => {
    setValue("employeeReferenceId", null, {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true
    });
    setValue("randomPractitioner", null, {
      shouldDirty: true,
      shouldValidate: true,
      shouldTouch: true
    });
  }, []);
  if (isFetching)
    return /* @__PURE__ */ jsx(EmployeeAutocompleteSkeleton, {});
  return /* @__PURE__ */ jsx(
    Controller,
    {
      name: `employeeByRole.${role}`,
      control,
      render: ({ field: { value, onChange, ...rest }, fieldState: { isTouched, error } }) => {
        const showError = !!error && isTouched;
        const disabled = !treatmentReferenceId;
        const isAllSelected = !!value.length && value.length === options.length;
        return /* @__PURE__ */ jsxs(FormControl, { fullWidth: true, children: [
          /* @__PURE__ */ jsx(
            StyledInputLabel,
            {
              shrink: !!value.length,
              sx: {
                paddingLeft: `${LABEL_OFFSET}px`,
                top: "8px"
              },
              children: labels.label
            }
          ),
          /* @__PURE__ */ jsxs(
            StyledSelect,
            {
              ...rest,
              multiple: true,
              onChange: handleEmployeeChange(onChange, value),
              startAdornment: /* @__PURE__ */ jsx(EmployeeIcon, {}),
              error: showError,
              fullWidth: true,
              variant: "filled",
              value,
              label: labels.label,
              onOpen: handleInputClick,
              onClose: handleSelectClose,
              open,
              disabled,
              MenuProps: menuProps,
              renderValue: (values) => {
                const chipsList = values.slice(0, maxChips);
                const hiddenChipsCount = values.slice(maxChips).length;
                return /* @__PURE__ */ jsxs(ChipsStack, { children: [
                  !isAllSelected && chipsList.map((option) => {
                    const employee = options.find(({ value: optionValue }) => optionValue.referenceId === option);
                    return /* @__PURE__ */ jsx(
                      Chip,
                      {
                        label: employee == null ? void 0 : employee.label,
                        onDelete: handleDeleteChip(option, value),
                        deleteIcon: /* @__PURE__ */ jsx(CrossIcon, {})
                      },
                      option
                    );
                  }),
                  !!hiddenChipsCount && !isAllSelected && /* @__PURE__ */ jsx(Button, { variant: "borderless", size: "sm", children: `+${hiddenChipsCount} more` }),
                  isAllSelected && /* @__PURE__ */ jsx(Chip, { label: labels.all, onDelete: handleDeleteAllChips, deleteIcon: /* @__PURE__ */ jsx(CrossIcon, {}) })
                ] });
              },
              children: [
                /* @__PURE__ */ jsx(MenuItem, { value: TOGGLE_ALL_VALUE, disableRipple: true, children: /* @__PURE__ */ jsxs(ToggleWrapper, { children: [
                  /* @__PURE__ */ jsx(Typography, { variant: "Lato Emphasized 1", children: `${labels.toggleAll} (${value.length}/${options.length})` }),
                  /* @__PURE__ */ jsx(Switch, { checked: isAllSelected, size: "small" })
                ] }) }),
                /* @__PURE__ */ jsx(Divider, {}),
                options.map((option) => {
                  var _a, _b, _c;
                  const selected = value.includes((_a = option.value) == null ? void 0 : _a.referenceId);
                  return /* @__PURE__ */ jsx(
                    MenuItem$1,
                    {
                      value: (_b = option.value) == null ? void 0 : _b.referenceId,
                      variant: "checkbox",
                      selected,
                      avatar: {
                        userName: option.label ?? "",
                        imageUrl: ((_c = option.value) == null ? void 0 : _c.imageUrl) ?? "",
                        // @ts-expect-error TODO:
                        ...!option.value && {
                          Icon: /* @__PURE__ */ jsx(Person, {})
                        }
                      },
                      children: option.label
                    },
                    option.label
                  );
                })
              ]
            }
          ),
          showError && /* @__PURE__ */ jsx(StyledFormHelperText, { children: labels.error })
        ] });
      }
    }
  );
};
export {
  EmployeeSelect
};
